import { createFileRoute } from "@tanstack/react-router";
import ProlivRx from "@/pages/ProlivRx";
export const Route = createFileRoute("/at-home-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Proliv®Rx At-Home TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Proliv®Rx is an FDA-cleared, at-home neuromodulation therapy for treatment-resistant depression. Learn how this personalized, non-invasive treatment works.",
        },
        {
          property: "og:title",
          content: "Proliv®Rx At-Home TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Proliv®Rx is an FDA-cleared, at-home neuromodulation therapy for treatment-resistant depression. Learn how this personalized, non-invasive treatment works.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/prolivrx",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/prolivrx",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ProlivRx />;
}
